export default "__VITE_ASSET__whVJogUh__"